export const getAddress = {
    data() {
        return {
            eircode: '',
            address: [],
            postcode_country: 'ie',
        }
    },
    computed: {
        addressString() {
            if (this.address.length == 0) {
                return '';
            }

            return this.address.join(' <br/> ');
        }  
    },
    watch: {
        eircode: function (val, oldVal) {
            if (oldVal.length != 0) {
                this.address = [];
                this.postcode_country = 'ie';
            }
        }
    },    
    methods: {
        getAddress() {
            //need to set the postcode country to ie to get it to validate each time. 
            this.postcode_country = 'ie';

            axios
                .post("/api/geo-directory", {
                    q: this.eircode,
                })
                .then(response => {                    
                    if(response.data.length === 0) {
                        return;
                    }

                    this.address = response.data.address;
                    this.postcode_country = response.data.postcode_country;
                })
                .catch(error => {
                });
        },
    }
}


